import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiIconComponent } from './icon.component';

@NgModule({
  declarations: [UiIconComponent],
  imports: [CommonModule],
  exports: [UiIconComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UiIconModule {}
